import { getSwallerMethods } from '../../Components/Swaller/swallerBridge'

/**
 * @author Tecnel MC
 * @name swaller
 * @description API for swallers - Now uses modern React components instead of sweetalert
 * @example
 * swaller.type('text to display to the user')
 * return true or false => answer of the user
 */

const swaller = {}

swaller.question = async (text, options = {}) => {
  try {
    const methods = getSwallerMethods()
    // Old API had dangerMode: true by default for questions
    const response = await methods.question(text, { dangerMode: options.dangerMode !== undefined ? options.dangerMode : true })
    return response
  } catch (err) {
    return false
  }
}

swaller.error = (text) => {
  try {
    const methods = getSwallerMethods()
    methods.error(text)
  } catch (err) {}
}

swaller.info = (text) => {
  try {
    const methods = getSwallerMethods()
    methods.info(text)
  } catch (err) {}
}

swaller.success = (text) => {
  try {
    const methods = getSwallerMethods()
    methods.success(text)
  } catch (err) {}
}

swaller.welcome = (text) => {
  try {
    const methods = getSwallerMethods()
    methods.welcome(text)
  } catch (err) {}
}

swaller.warning = (text) => {
  try {
    const methods = getSwallerMethods()
    methods.warning(text)
  } catch (err) {}
}

swaller.input = async (text, placeholder = '') => {
  try {
    const methods = getSwallerMethods()
    const response = await methods.input(text, placeholder)
    return response
  } catch (err) {
    return null
  }
}

export default swaller
